import { IEventsState } from '@/@types'

const state: IEventsState = {
  utmParams: null,
  dataLayer: {
    event: '',
    value: {},
  },
}

export default state
